import React from 'react';
import { Box, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { ContentContainer } from 'components/styles_components/container';
import { ChapterTypography } from 'components/styles_components/typography';

const Section = ({ titleId, children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
      <FormattedMessage id={titleId} />
    </Typography>
    {children}
  </Box>
);

const P = ({ id }) => (
  <Typography variant="body1" sx={{ mb: 1 }}>
    <FormattedMessage id={id} />
  </Typography>
);

const Li = ({ id }) => (
  <Typography variant="body1" component="li" sx={{ ml: 3, mb: 0.5 }}>
    <FormattedMessage id={id} />
  </Typography>
);

const PrivacyPolicy = () => {
  return (
    <ContentContainer maxWidth="md">
      <ChapterTypography variant="h5" align="center">
        <FormattedMessage id="legal.privacy.title" />
      </ChapterTypography>
      <Typography variant="subtitle1" align="center" sx={{ mb: 4 }}>
        <FormattedMessage id="legal.privacy.subtitle" />
      </Typography>

      <Section titleId="legal.privacy.s1.title">
        <P id="legal.privacy.s1.p1" />
        <P id="legal.privacy.s1.p2" />
      </Section>

      <Section titleId="legal.privacy.s2.title">
        <P id="legal.privacy.s2.p1" />
        <ul>
          <Li id="legal.privacy.s2.li1" />
          <Li id="legal.privacy.s2.li2" />
          <Li id="legal.privacy.s2.li3" />
          <Li id="legal.privacy.s2.li4" />
          <Li id="legal.privacy.s2.li5" />
          <Li id="legal.privacy.s2.li6" />
        </ul>
      </Section>

      <Section titleId="legal.privacy.s3.title">
        <P id="legal.privacy.s3.p1" />
        <ul>
          <Li id="legal.privacy.s3.li1" />
          <Li id="legal.privacy.s3.li2" />
          <Li id="legal.privacy.s3.li3" />
          <Li id="legal.privacy.s3.li4" />
          <Li id="legal.privacy.s3.li5" />
          <Li id="legal.privacy.s3.li6" />
        </ul>
      </Section>

      <Section titleId="legal.privacy.s4.title">
        <P id="legal.privacy.s4.p1" />
        <ul>
          <Li id="legal.privacy.s4.li1" />
          <Li id="legal.privacy.s4.li2" />
          <Li id="legal.privacy.s4.li3" />
        </ul>
      </Section>

      <Section titleId="legal.privacy.s5.title">
        <P id="legal.privacy.s5.p1" />
        <ul>
          <Li id="legal.privacy.s5.li1" />
          <Li id="legal.privacy.s5.li2" />
        </ul>
      </Section>

      <Section titleId="legal.privacy.s6.title">
        <P id="legal.privacy.s6.p1" />
        <ul>
          <Li id="legal.privacy.s6.li1" />
          <Li id="legal.privacy.s6.li2" />
          <Li id="legal.privacy.s6.li3" />
        </ul>
      </Section>

      <Section titleId="legal.privacy.s7.title">
        <P id="legal.privacy.s7.p0" />
        <P id="legal.privacy.s7.p1" />
        <P id="legal.privacy.s7.p2" />
        <P id="legal.privacy.s7.p3" />
        <P id="legal.privacy.s7.p4" />
        <P id="legal.privacy.s7.p5" />
        <P id="legal.privacy.s7.p6" />
      </Section>

      <Section titleId="legal.privacy.s8.title">
        <P id="legal.privacy.s8.p1" />
        <ul>
          <Li id="legal.privacy.s8.li1" />
          <Li id="legal.privacy.s8.li2" />
          <Li id="legal.privacy.s8.li3" />
          <Li id="legal.privacy.s8.li4" />
        </ul>
        <P id="legal.privacy.s8.p2" />
        <P id="legal.privacy.s8.p3" />
        <P id="legal.privacy.s8.p4" />
      </Section>

      <Section titleId="legal.privacy.s9.title">
        <P id="legal.privacy.s9.p1" />
      </Section>

      <Section titleId="legal.privacy.s10.title">
        <P id="legal.privacy.s10.p1" />
        <ul>
          <Li id="legal.privacy.s10.li1" />
          <Li id="legal.privacy.s10.li2" />
        </ul>
      </Section>

      <Section titleId="legal.privacy.s11.title">
        <P id="legal.privacy.s11.p1" />
        <P id="legal.privacy.s11.p2" />
        <P id="legal.privacy.s11.p3" />
      </Section>

      <Typography variant="body2" align="center" sx={{ mt: 4, color: 'text.secondary' }}>
        <FormattedMessage id="legal.trademark" />
      </Typography>
    </ContentContainer>
  );
};

export default PrivacyPolicy;
